import { Channel } from '@shared/interfaces/channel';
import { Observable } from 'rxjs';

export const CHANNEL_REPOSITORY = 'ChannelsRepository';

export interface ChannelsRepository {
  url: string;

  getItems(): Observable<any>;

  add(channel: Channel): Observable<any>;

  edit(channel: Channel): Observable<any>;

  delete(item: any): Observable<any>;
}
